import { cn } from '@crossnokaye/ux-common';

interface AppContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

export const AppContainer = ({ children, className, ...props }: AppContainerProps) => {
  return (
    <div className={cn('flex flex-row flex-1 min-h-0', className)} {...props}>
      {children}
    </div>
  );
};
